module.exports = __webpack_public_path__ + "static/media/Rotated tooth5.7966cdb9.png";